import { Message } from "../AppState"
import CounterStack from "./CounterStack"
import { format_name } from "../util"



export default function CounterBox({name, n_counters, sendJsonMessage, location, updateCounter}: 
    {name: string, n_counters: number, 
        sendJsonMessage: (msg: Message)=>void, location: {row: number, column:number},
    updateCounter: any
}): any {

    const takeCounter = n_counters > 0 ? ()=>{
        sendJsonMessage({
        kind: 'counterUpdate',
        playbook: name,
        delta: -1
        });
        updateCounter(true);
    } : ()=>{}

    const putCounter = ()=>{
        sendJsonMessage({
            kind: 'counterUpdate',
            playbook: name,
            delta: 1
        });
        updateCounter(false)
    }

    console.log(updateCounter)

    return (
        <div id={name} className="card"
            style={{
                gridRow: location.row,
                gridColumn: location.column,
            }}
            onMouseDown={takeCounter}
            onMouseUp={putCounter}
        >
           <h4> {format_name(name)} </h4>
           <CounterStack size={n_counters} />
           <p> {n_counters} counters </p>    
        </div>
    )
}